import { render, staticRenderFns } from "./book-sort-selector.vue?vue&type=template&id=351563b7&scoped=true"
import script from "./book-sort-selector.vue?vue&type=script&lang=ts"
export * from "./book-sort-selector.vue?vue&type=script&lang=ts"
import style0 from "./book-sort-selector.vue?vue&type=style&index=0&id=351563b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351563b7",
  null
  
)

export default component.exports